export default `
<section class="third bg-white container ">
        <h2 class="h2 mb-2 mt-4">++{{section1Header}}</h2>
        <h6 class="p mb-3" >++{{section1Text}}</h6>		
</section>
`;